export const de = {
	general: {
		name: "Aquila Real GmbH",
		locales: {
			de: "DE",
			en: "EN",
		},
	},
	navigation: {
		profile: "Ankaufsprofil",
		company: "Unternehmen",
		objects: "Ausgewählte Objekte",
		contact: "Kontakt",
	},
	hero: {
		contact: "Zum Kontakt",
		slogan: "nachhaltig, unabhängig, partnerschaftlich",
	},
	home: {
		hero: {
			title: "Berlin",
		},
	},
	profile: {
		title: "Ankaufsprofil",
		description:
			"Die Erweiterung unseres Portfolios gemäß der folgenden Kriterien ist eines unserer zentralen Anliegen. Kurze Entscheidungswege und die frühzeitige Einbindung von Entscheidungsträgern gestalten unsere Transaktionsprozesse dabei in hohem Maße agil und verlässlich.",
		list: {
			assetClasses: {
				title: "Assetklassen",
				values: [
					"• Büro",
					"• Logistik, Light Industrial, Urban Logistics",
					"• Einzelhandel (Fachmarktzentren, Lebensmitteleinzelhandel)",
					"• Hotel, Boardinghäuser",
					"• Wohn- und Geschäftshäuser",
				],
			},
			location: {
				title: "Standorte",
				values: [
					"• Deutschlandweit Städte ab 100.000 Einwohner",
					"• Für Logistik: Etablierte Logistikstandorte in Metropolregionen",
				],
			},
			riskClassAndProperties: {
				title: "Risikoklassen & Eigenschaften",
				values: [
					"Core Plus - Value Add:",
					"• Voll vermietet bis 100% Leerstand",
					"• Sehr gute bis mittlere Objektqualität",
					"• Langfristiges Wertschöpfungs- und Entwicklungspotential",
					"• Refurbishments",
				],
			},
			volume: {
				title: "VOLUMEN",
				values: ["ab EUR 3 Mio."],
			},
		},
		hint: {
			title: "Makler-Hinweis:",
			text: "Selbstverständlich stellt das vorliegende Ankaufsprofil kein Angebot zum Abschluss eines Maklervertrages dar, sondern dient ausschließlich Informationszwecken betreffend die Tätigkeit und die Investitionsziele der Aquila Real Unternehmensgruppe. Es wird daher ausdrücklich darauf hingewiesen, dass Maklerprovisionen ausschließlich auf Basis schriftlich geschlossener Maklerverträge vergütet werden.",
		},
	},
	objects: {
		title: "Ausgewählte Objekte",
		elements: [
			{
				title: "Berlin - Hotel",
				description:
					"Revitalisierung eines Boutique-Hotels in Berliner Bestlage (1.000 qm)",
			},
			{
				title: "Bonn - Einzelhandel / Mixed Use",
				description:
					"Gemischt-genutztes Gebäudeensemble mit Einzelhandelsschwerpunkt in zentrumsnahem Gewerbegebiet (10.400 qm)",
			},
			{
				title: "Hamm - Einzelhandel / Fachmarktzentrum",
				description:
					"Fachmarktzentrum mit Baumarkt als Ankermieter in stark nachgefragtem Gewerbegebiet im Westen Hamms (12.300 qm)",
			},
		],
	},
	company: {
		title: "Unternehmen",
		description: [
			"Die Aquila Real Gruppe ist ein inhabergeführtes und unabhängiges Immobilien-Investmentunternehmen.",
			"Der Anlagefokus liegt deutschlandweit auf Einzel- sowie Portfolio-Transaktionen in allen Asset-Klassen. Hohe Transaktionssicherheit, zügige Abwicklung und partnerschaftlicher Umgang, angelegt auf dauerhafte Geschäftsbeziehungen, sind die vordersten Ansprüche der Aquila Real Gruppe.",
			"Unsere Mitarbeiter verfügen über umfangreiche Erfahrung in Investment & Asset Management und Projektentwicklung. Zugleich profitieren wir von einem hervorragenden und über Jahre erarbeiteten Netzwerk hochkarätiger und zuverlässiger Partner.",
		],
	},
	contact: {
		phone: "KzQ5IDQwIDgwOTA4MTQ2Mg==",
		address: ["Rutschbahn 39", "20146 Hamburg"],
		email: "aW52ZXN0bWVudEBhcXVpbGEtcmVhbC5kZQ==",
	},
	disclaimer: {
		hero: {
			title: "Haftungsausschluss",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
	terms: {
		hero: {
			title: "AGB",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
	privacy: {
		hero: {
			title: "Datenschutz",
		},
		paragraphs: [
			{ type: "headline", text: "Gemeinsame Verantwortliche " },
			{
				type: "text",
				text: "Die Aquila Real GmbH ist für die Verarbeitung der über die Webseite (www.aquila-real.de) erhobenen und gespeicherten  personenbezogenen  Daten  für  die  nachfolgend  aufgeführten  Zwecke  sowie  den  Schutz  der Daten entsprechend den nachfolgenden Bestimmungen verantwortlich (Art. 26 DSGVO).",
			},
			{
				type: "text",
				text: "Sie  können  Ihre  Datenschutzrechte  gegenüber  der  Aquila  Real  GmbH  geltend  machen  und  erhalten Auskunft über Ihre bei der Aquila Real GmbH gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO).",
			},
			{ type: "text", text: "Die Anschrift der Aquila Real GmbH lautet:" },
			{
				type: "text-pre",
				text: "Aquila Real GmbH\nRutschbahn 39\n20146 Hamburg",
			},
			{ type: "text-pre", text: "Vertreten durch:\nLeon Thomsen" },
			{
				type: "text-pre",
				text: "Telefon: +49 (0) 40 80 90 81 462\nE-Mail: kontakt@aquila-real.de",
			},
			{ type: "headline", text: "Ihre Betroffenenrechte" },
			{
				type: "text-pre",
				text: "Unter den vorstehend angegebenen Kontaktdaten können Sie jederzeit folgende Rechte ausüben:\n• Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),\n• Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),\n• Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),\n• Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),\n• Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und\n• Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO).",
			},
			{
				type: "text",
				text: "Sofern  Sie  uns  eine  Einwilligung  erteilt  haben,  können  Sie  diese  jederzeit  mit  Wirkung  für  die  Zukunft widerrufen. Ihr Widerruf berührt jedoch nicht die Rechtmäßigkeit der Verarbeitung auf der Grundlage Ihrer Einwilligung bis zu dem Widerruf.Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als Verantwortlichem zuständige Behörde.Eine   Liste   der   Aufsichtsbehörden   (für   den   nichtöffentlichen   Bereich)   mit   Anschrift   finden   Sie unter: https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.",
			},
			{
				type: "headline",
				text: "Erfassung allgemeiner Informationen beim Besuch unserer Website",
			},
			{ type: "headline", text: "Art und Zweck der Verarbeitung:" },
			{
				type: "text",
				text: "Wenn   Sie   auf   unsere   Website   zugreifen,   d.h.,   wenn   Sie   sich   nicht   registrieren   oder   anderweitig Informationen   übermitteln,   werden   automatisch   Informationen   allgemeiner   Natur   erfasst.   Diese Informationen    (Server-Logfiles)    beinhalten    etwa    die    Art    des    Webbrowsers,    das    verwendete Betriebssystem, den Domainnamen Ihres Internet-Service-Providers, Ihre IP-Adresse und ähnliches. Sie werden insbesondere zu folgenden Zwecken verarbeitet:",
			},
			{
				type: "text-pre",
				text: "• Sicherstellung eines problemlosen Verbindungsaufbaus der Website,\n• Sicherstellung einer reibungslosen Nutzung unserer Website,\n• Auswertung der Systemsicherheit und -stabilität sowie\n• zur Optimierung unserer Website.",
			},
			{
				type: "text",
				text: "Wir  verwenden  Ihre  Daten  nicht,  um  Rückschlüsse  auf  Ihre  Person  zu  ziehen.  Informationen  dieser  Art werden   von   uns   ggfs.   anonymisiert   statistisch   ausgewertet,   um   unseren   Internetauftritt   und   die dahinterstehende Technik zu optimieren. ",
			},
			{ type: "headline", text: "Rechtsgrundlage und berechtigtes Interesse:" },
			{
				type: "text",
				text: "Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der Verbesserung der Stabilität und Funktionalität unserer Website.",
			},
			{ type: "headline", text: "Empfänger:" },
			{
				type: "text",
				text: "Empfänger der Daten sind technische Dienstleister, die für den Betrieb und die Wartung unserer Webseite als Auftragsverarbeiter tätig werden.",
			},
			{ type: "headline", text: "Drittlandtransfer:" },
			{
				type: "text",
				text: "Die erhobenen Daten werden in Drittländer übertragen: Nein.",
			},
			{ type: "headline", text: "Speicherdauer:" },
			{
				type: "text",
				text: "Die Daten werden gelöscht, sobald diese für den Zweck der Erhebung nicht mehr erforderlich sind. Dies ist für die Daten, die der Bereitstellung der Website dienen, grundsätzlich der Fall, wenn die jeweilige Sitzung beendet ist. ",
			},
			{
				type: "headline",
				text: "Bereitstellung vorgeschrieben oder erforderlich:",
			},
			{
				type: "text",
				text: "Die  Bereitstellung  der  vorgenannten  personenbezogenen  Daten  ist  weder  gesetzlich  noch  vertraglich vorgeschrieben. Ohne die IP-Adresse ist jedoch der Dienst und die Funktionsfähigkeit unserer Website nicht gewährleistet. Zudem können einzelne Dienste und Services nicht verfügbar oder eingeschränkt sein.",
			},
			{
				type: "headline",
				text: "Datenverarbeitung aufgrund einer gesetzlichen Pflicht",
			},
			{ type: "headline", text: "Art und Zweck der Verarbeitung:" },
			{
				type: "text",
				text: "Wir  unterliegen  gesetzlichen  Verpflichtung  personenbezogene  Daten  zu  verarbeiten,  zum  Beispiel  nach Handelsrecht oder Steuerrecht.",
			},
			{ type: "headline", text: "Rechtsgrundlage:" },
			{
				type: "text",
				text: "Unterliegen wir einer rechtlichen Verpflichtung, durch welche eine Verarbeitung von personenbezogenen Daten erforderlich wird, so basiert die Verarbeitung auf Art. 6 I lit. c DSGVO.",
			},
			{ type: "headline", text: "Empfänger:" },
			{
				type: "text",
				text: "Die Daten werden für die vorstehenden Zwecke erforderlichenfalls an unsere externen Berater übermittelt. Empfänger  der  Daten  sind  technische  Dienstleister,  die  für  den  Betrieb  und  die  Wartung  unserer Datenverarbeitungsanlagen als Auftragsverarbeiter tätig werden.",
			},
			{ type: "headline", text: "Drittlandtransfer:" },
			{
				type: "text",
				text: "Die erhobenen Daten werden in Drittländer übertragen: Nein.",
			},
			{ type: "headline", text: "Speicherdauer:" },
			{
				type: "text",
				text: "Die Speicherdauer entspricht grundsätzlich nach den vorstehend genannten Fristen bei der Verarbeitung zur Vertragsdurchführung.",
			},
			{
				type: "headline",
				text: "Bereitstellung vorgeschrieben oder erforderlich:",
			},
			{
				type: "text",
				text: "Die Bereitstellung der Daten ist im Rahmen des Vertragsabschlusses verpflichtend.",
			},
			{ type: "headline", text: "Geltendmachung von Rechtsansprüchen" },
			{ type: "headline", text: "Art und Zweck der Verarbeitung:" },
			{
				type: "text",
				text: "Gegebenenfalls verarbeiten wir Daten, soweit dies für die Geltendmachung oder Durchsetzung rechtlicher Ansprüche und Verteidigung bei rechtlichen Streitigkeiten erforderlich ist.",
			},
			{ type: "headline", text: "Rechtsgrundlage:" },
			{
				type: "text",
				text: "Die    Verarbeitung    erfolgt    zur    Wahrung    unserer    berechtigten    Interessen    an    der    angemessenen Wahrnehmung der rechtlichen Belange (Art. 6 I lit. f DSGVO).",
			},
			{ type: "headline", text: "Empfänger:" },
			{
				type: "text",
				text: "Empfänger können alle an einem Rechtsstreit Beteiligte sowie unsere externen Berater sein. Darüber  hinaus  sind  Empfänger  der  Daten  technische  Dienstleister,  die  für  den  Betrieb  und  die  Wartung unserer Datenverarbeitungsanlagen als Auftragsverarbeiter tätig werden.",
			},
			{ type: "headline", text: "Drittlandtransfer:" },
			{
				type: "text",
				text: "Die erhobenen Daten werden in Drittländer übertragen: Nein.",
			},
			{ type: "headline", text: "Speicherdauer:" },
			{
				type: "text",
				text: "Die Speicherdauer entspricht grundsätzlich nach den vorstehend genannten Fristen bei der Verarbeitung zur Vertragsdurchführung.",
			},
			{
				type: "headline",
				text: "Bereitstellung vorgeschrieben oder erforderlich:",
			},
			{
				type: "text",
				text: "Die Bereitstellung der Daten ist im Rahmen des Vertragsabschlusses verpflichtend.",
			},
			{ type: "headline", text: "Verwendung von Google Maps" },
			{
				type: "text",
				text: "Auf  dieser  Website  nutzen  wir  das  Angebot  von  Google  Maps.  Google  Maps  wird  von  Google  LLC,  1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (nachfolgend „Google“) betrieben. Dadurch können wir  Ihnen  interaktive  Karten  direkt  in  der  Webseite  anzeigen  und  ermöglichen  Ihnen  die  komfortable Nutzung der Karten-Funktion.Nähere    Informationen    über    die    Datenverarbeitung    durch    Google    können    Sie    den    Google-Datenschutzhinweisen entnehmen: https://policies.google.com/privacy. Dort können Sie im Datenschutzcenter auch Ihre persönlichen Datenschutz-Einstellungen verändern.Ausführliche  Anleitungen  zur  Verwaltung  der  eigenen  Daten  im  Zusammenhang  mit  Google-Produkten finden Sie hier: https://www.dataliberation.orgDurch den Besuch der Website erhält Google Informationen, dass Sie die entsprechende Unterseite unserer Webseite  aufgerufen  haben.  Dies  erfolgt  unabhängig  davon,  ob  Google  ein  Nutzerkonto  bereitstellt,  über das Sie eingeloggt sind, oder ob keine Nutzerkonto besteht. Wenn Sie bei Google eingeloggt sind, werden Ihre Daten direkt Ihrem Konto zugeordnet. Wenn Sie die Zuordnung in Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung des Buttons bei Google ausloggen. Google speichert Ihre Daten als Nutzungsprofile und nutzt sie für Zwecke der Werbung, Marktforschung und/oder bedarfsgerechter Gestaltung seiner Websites. Eine solche Auswertung erfolgt insbesondere (selbst für nicht eingeloggte Nutzer) zur Erbringung bedarfsgerechter Werbung und um andere Nutzer des sozialen Netzwerks über Ihre Aktivitäten auf unserer Website zu informieren. Ihnen steht ein Widerspruchsrecht zu gegen die Bildung dieser Nutzerprofile, wobei Sie sich zur Ausübung dessen an Google richten müssen.",
			},
			{ type: "headline", text: "Widerruf der Einwilligung:" },
			{
				type: "text",
				text: "Vom  Anbieter  wird  derzeit  keine  Möglichkeit  für  einen  einfachen  Opt-out  oder  ein  Blockieren  der Datenübertragung  angeboten.  Wenn  Sie  eine  Nachverfolgung  Ihrer  Aktivitäten  auf  unserer  Website verhindern  wollen,  widerrufen  Sie  bitte  im  Cookie-Consent-Tool  Ihre  Einwilligung  für  die  entsprechende Cookie-Kategorie oder alle technisch nicht notwendigen Cookies und Datenübertragungen. In diesem Fall können Sie unsere Website jedoch ggfs. nicht oder nur eingeschränkt nutzen.",
			},
			{ type: "headline", text: "SSL-Verschlüsselung" },
			{
				type: "text",
				text: "Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.",
			},
			{
				type: "headline",
				text: "Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO",
			},
			{ type: "headline", text: "Einzelfallbezogenes Widerspruchsrecht" },
			{
				type: "text",
				text: "Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund Art. 6 Abs. 1 lit. f DSGVO (Datenverarbeitung  auf  der  Grundlage  einer  Interessenabwägung)  erfolgt,  Widerspruch  einzulegen;  dies  gilt auch für ein auf diese Bestimmung gestütztes Profiling im Sinne von Art. 4 Nr. 4 DSGVO.Legen  Sie  Widerspruch  ein,  werden  wir  Ihre  personenbezogenen  Daten  nicht  mehr  verarbeiten,  es  sei denn,   wir   können   zwingende   schutzwürdige   Gründe   für   die   Verarbeitung   nachweisen,   die   Ihre Interessen,  Rechte  und  Freiheiten  überwiegen,  oder  die  Verarbeitung  dient  der  Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.Bitte richten Sie Ihren Widerspruch an unsere vorstehend genannten Kontaktdaten.",
			},
			{ type: "headline", text: "Änderung unserer Datenschutzbestimmungen" },
			{
				type: "text",
				text: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.",
			},
			{ type: "headline", text: "Fragen zum Datenschutz" },
			{
				type: "text",
				text: "Wenn  Sie  Fragen  zum  Datenschutz  haben,  schreiben  Sie  uns  bitte  eine  E-Mail  an  unsere  vorstehend genannte E-Mail-Adresse oder schreiben Sie uns an die vorstehend genannte Anschrift.",
			},
		],
	},
	imprint: {
		hero: {
			title: "Impressum",
		},
		paragraphs: [
			{
				type: "text-pre",
				text: "Angaben gemäß §5 TMG\nAquila Real GmbH\nRutschbahn 39\nHamburg",
			},
			{
				type: "text-pre",
				text: "Handelsregister: HRB 170827\nRegistergericht: Hamburg",
			},
			{ type: "text-pre", text: "Vertreten durch:\nLeon Thomsen" },
			{ type: "headline", text: "Kontakt" },
			{
				type: "text-pre",
				text: "Telefon: +49 (0) 40 80 90 81 462\nTelefax: +49 (0) 40 35 67 48 61\nE-Mail: kontakt@aquila-real.de",
			},
			{ type: "headline", text: "Umsatzsteuer-ID" },
			{
				type: "text-pre",
				text: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:\nDE346358442",
			},
			{
				type: "headline",
				text: "Haftungsausschluss (Disclaimer) Haftung für Inhalte",
			},
			{
				type: "text",
				text: "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
			},
			{
				type: "text",
				text: "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
			},
			{ type: "headline", text: "Haftung für Links" },
			{
				type: "text",
				text: "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.",
			},
			{
				type: "text",
				text: "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
			},
			{ type: "headline", text: "Urheberrecht" },
			{
				type: "text",
				text: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.",
			},
			{
				type: "text",
				text: "Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
			},
		],
	},
};

export type Texts = typeof de;
